import { Icon } from '@shopify/polaris';
import { AlertCircleIcon, CheckCircleIcon, InfoIcon, XIcon } from '@shopify/polaris-icons';

export type AdminToast = {
  id: string;
  tone: 'success' | 'critical' | 'warning' | 'info';
  title: string;
  message?: string;
};

export function AdminToastHost({
  toasts,
  onDismiss,
}: {
  toasts: AdminToast[];
  onDismiss: (id: string) => void;
}) {
  if (!toasts.length) return null;

  const iconForTone = (tone: AdminToast['tone']) => {
    if (tone === 'success') return CheckCircleIcon;
    if (tone === 'info') return InfoIcon;
    return AlertCircleIcon;
  };

  return (
    <div className="admin-toast-host" role="status" aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <div key={toast.id} className={`admin-toast admin-toast--${toast.tone}`}>
          <span className="admin-toast__icon"><Icon source={iconForTone(toast.tone)} /></span>
          <span className="admin-toast__copy">
            <strong>{toast.title}</strong>
            {toast.message ? <span>{toast.message}</span> : null}
          </span>
          <button type="button" className="admin-toast__close" onClick={() => onDismiss(toast.id)} aria-label="Закрити повідомлення">
            <Icon source={XIcon} />
          </button>
        </div>
      ))}
    </div>
  );
}
